import { render } from "./Dynamic.vue?vue&type=template&id=4a15bcbe&scoped=true"
import script from "./Dynamic.vue?vue&type=script&lang=js"
export * from "./Dynamic.vue?vue&type=script&lang=js"

import "./Dynamic.vue?vue&type=style&index=0&id=4a15bcbe&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a15bcbe"]])

export default __exports__